export class StorePaymentSettingsEntity {
  id: number

  userId: string

  companyEntityId: number

  isConnectedApi: boolean

  isOnlinePaymentEnabled: boolean

  isInPersonOrderPaymentEnabled: boolean

  mercadoPagoUserId: string

  mercadoPagoTokenExpiresAt: Date | null

  hasOAuthCredentials: boolean

  needsReconnect: boolean

  createdAt: Date

  updatedAt: Date

  constructor(data: Partial<StorePaymentSettingsEntity>) {
    this.id = data.id ?? 0

    this.userId = data.userId ?? ""

    this.isConnectedApi = data.isConnectedApi ?? false

    this.companyEntityId = data.companyEntityId ?? 0

    this.isOnlinePaymentEnabled = data.isOnlinePaymentEnabled ?? false

    this.isInPersonOrderPaymentEnabled = data.isInPersonOrderPaymentEnabled ?? false

    this.mercadoPagoUserId = data.mercadoPagoUserId ?? ""

    this.mercadoPagoTokenExpiresAt = data.mercadoPagoTokenExpiresAt ? new Date(data.mercadoPagoTokenExpiresAt) : null

    this.hasOAuthCredentials = data.hasOAuthCredentials ?? false

    this.needsReconnect = data.needsReconnect ?? false

    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date()

    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date()
  }
}
